import { render, staticRenderFns } from "./SwipeTabBlur.vue?vue&type=template&id=0919d586"
import script from "./SwipeTabBlur.vue?vue&type=script&lang=js"
export * from "./SwipeTabBlur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports